<template>
  <CardModule
    class="mt-6"
    :title="$t('registrations.producers.sales-settings')"
  >
    <v-row>
      <v-col cols="12" sm="6">
        <v-radio-group
          v-model="$loja_gerenciar.cadastro.configuracoes_rede.rede_vendas"
          class="mt-0"
          hide-details
        >
          <template v-slot:label>
            <div class="">
              {{ $t("registrations.producers.sales-network") }}:
            </div>
          </template>
          <v-radio
            value="COMPARTILHADA"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                {{ $t("registrations.producers.shared-network") }}<br />
                <small></small>
              </div>
            </template>
          </v-radio>
          <v-radio
            value="PRIVADA"
            v-if="isPrivateNetwork"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                {{ $t("registrations.producers.exclusive-network") }}<br />
                <small></small>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row v-if="isPrivateNetwork">
      <v-row class="mt-2">
        <v-col cols="12" sm="6">
          <span>
            {{ $t("registrations.producers.sale-channels") }} -
            {{ $t("registrations.producers.exclusive-network") }}:
          </span>
          <v-checkbox
            v-model="$loja_gerenciar.cadastro.configuracoes_rede.rede_privada"
            :label="$t('registrations.producers.point-of-sale')"
            class="checkbox-redes"
            value="PDV_POS"
          ></v-checkbox>
          <div class="d-flex">
            <v-checkbox
              v-model="$loja_gerenciar.cadastro.configuracoes_rede.rede_privada"
              label="E-commerce"
              class="checkbox-redes"
              value="ECOMMERCE"
            >
            </v-checkbox>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <div class="info-tool mr-5 mt-5" v-bind="attrs" v-on="on">
                  <InfoIcon />
                </div>
              </template>
              <span>
                {{ $t("registrations.producers.whitelabel-info") }}
              </span>
            </v-tooltip>
          </div>
        </v-col>
        <v-col cols="12" sm="2">
          <v-row>
            <BaseTextField
              :label="$t('registrations.producers.salesdiscount-in-channel')"
              hide-details
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.PDV_POS
              "
              class="pt-11"
              placeholder="0%"
              type="number"
            />
          </v-row>
          <v-row>
            <BaseTextField
              hide-details
              :label="$t('registrations.producers.salesdiscount-in-channel')"
              class="pt-6"
              placeholder="0%"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.ECOMMERCE
              "
              type="number"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-row>
    <v-row
      v-if="
        $loja_gerenciar.cadastro.configuracoes_rede.rede_vendas ==
        'COMPARTILHADA'
      "
    >
      <v-col cols="12">
        <span>
          {{ $t("registrations.producers.sale-channels") }} -
          {{ $t("registrations.producers.shared-network") }}:
        </span>
        <v-row class="align-center mt-1">
          <v-col cols="6">
            <v-checkbox
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada
              "
              :label="$t('registrations.producers.point-of-sale')"
              value="PDV_POS"
              class="mt-0"
              hide-details
            >
            </v-checkbox>
          </v-col>
          <v-col cols="6">
            <BaseTextField
              hide-details
              :label="$t('registrations.producers.discount-in-channel')"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.PDV_POS
              "
              placeholder="0%"
              class="mt-0"
              type="number"
            />
          </v-col>
        </v-row>

        <v-row class="align-center">
          <v-col cols="6">
            <v-checkbox
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada
              "
              class="mt-0"
              label="ElevenTickets E-commerce"
              value="MARKETPLACE"
              hide-details
            >
            </v-checkbox>
          </v-col>
          <v-col cols="6">
            <BaseTextField
              :label="$t('registrations.producers.discount-in-channel')"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.MARKETPLACE
              "
              class="mt-0"
              placeholder="0%"
              type="number"
              hide-details
            />
          </v-col>
        </v-row>

        <v-row class="align-center">
          <v-col cols="6">
            <v-checkbox
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede.rede_compartilhada
              "
              class="mt-0"
              value="ECOMMERCE"
              hide-details
            >
              <template v-slot:label>
                Whitelabel
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-icon class="ml-1">mdi-information-outline</v-icon>
                    </div>
                  </template>
                  <span>
                    {{ $t("registrations.producers.whitelabel-info") }}
                  </span>
                </v-tooltip>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="6">
            <BaseTextField
              :label="$t('registrations.producers.discount-in-channel')"
              v-model="
                $loja_gerenciar.cadastro.configuracoes_rede
                  .canal_venda_descontos.ECOMMERCE
              "
              placeholder="0%"
              type="number"
              hide-details
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <v-radio-group
          v-model="$loja_gerenciar.cadastro.dados_cadastrais.tipo_slug"
          hide-details
        >
          <template v-slot:label>
            <div>{{ $t("registrations.producers.store-link") }}:</div>
          </template>
          <v-radio
            value="DEFAULT"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                {{ $t("registrations.producers.default") }}<br />
                <small></small>
              </div>
            </template>
          </v-radio>
          <v-radio
            value="CUSTOM"
            class="rounded-lg pa-2"
            style="border: 1px solid rgb(0 0 0 / 42%)"
            active-class="active-class"
          >
            <template v-slot:label>
              <div>
                {{ $t("registrations.producers.custom") }}<br />
                <small></small>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mb-n7">
        <BaseTextField
          counter="15"
          suffix=".eleven360.com"
          :placeholder="$t('registrations.producers.type-in-store-url')"
          :label="$t('registrations.producers.store-link')"
          :hint="$t('registrations.producers.store-link-hint')"
          :rules="defaultSlug ? [] : [rules.required]"
          :disabled="defaultSlug"
          v-model="$loja_gerenciar.cadastro.dados_cadastrais.slug_loja"
          type="tel"
        />
      </v-col>
      <v-col cols="12" class="mb-7">
        <v-checkbox
          v-model="$loja_gerenciar.cadastro.configuracoes_rede.validar_cpf"
          :label="$t('registrations.producers.assertiva-integration')"
        >
        </v-checkbox>
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import CardModule from "@/components/cards/CardModule.vue";
import BaseTextField from "../forms/BaseTextField.vue";
import mixins from "@/mixins";

const { formRules } = mixins;
export default {
  name: "lojas-gerenciar-rede-compartilhada",
  mixins: [LojasGerenciarMixins, formRules],
  data() {
    return {
      addPdv: [],
    };
  },
  components: {
    CardModule,
    InfoIcon: () => import("@/components/icons/InfoIcon.vue"),
    BaseTextField,
  },
  computed: {
    defaultSlug() {
      return this.$loja_gerenciar.cadastro.dados_cadastrais.tipo_slug ==
        "DEFAULT"
        ? true
        : false;
    },
    isPrivateNetwork() {
      return (
        this.$loja_gerenciar.cadastro.configuracoes_rede.rede_vendas ==
          "PRIVADA" && this.$route.params.type == "editar"
      );
    },
  },
};
</script>
<style scoped>
.info-tool {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50px;
  margin-left: 0.325rem;
  cursor: pointer;
}
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
.checkbox-redes {
  margin-left: 0.625rem;
}

.lojas-gerenciar-rede-compartilhada-desconto {
  width: 100%;
  border-radius: 0.625rem;
}
</style>
